<template>
	<nav class="sub-navigation" v-sticky>
		<ul>
			<li
				v-for="item in items"
				:key="item.key"
				:class="{'active': page === item.key}"
			>
				<a v-if="item.url" :href="item.url">
					<Icon :icon="item.icon"/>
					<span class="text">{{ item.text }}</span>
				</a>
				<span v-else>
					<Icon :icon="item.icon"/>
					<span class="text">{{ item.text }}</span>
				</span>
				<template v-if="customer && item.key === 'job-profiles'">
					<a
						v-for="jobProfile in customer.jobProfiles"
						:key="jobProfile.id"
						:href="'/kundenbereich/jobs/' + jobProfile.id"
						:class="['sub-link', {'sub-link-active': subLinkActiveKey === jobProfile.id}]"
					>
						{{ jobProfile.name }}
						<span v-if="jobProfile.newMessagesCount > 0" class="highlight"></span>
					</a>
					<a
						href="/kundenbereich/jobs/anlegen"
						:class="['sub-link', {'sub-link-active': subLinkActiveKey === 'addJobProfile'}]"
					>
						<Icon icon="plus"/>
						Neuen Job anlegen
					</a>
				</template>
			</li>
			<li v-if="shouldShow('logout')">
				<a href="#" @click.prevent="logout">
					<Icon icon="logout"/>
					<span class="text">Abmelden</span>
				</a>
			</li>
		</ul>
		<div
			v-if="customer && page === 'job-profiles' && shouldShow('job-profiles')"
			class="sub-navigation--job-profiles"
		>
			<div>
				<Select
					:options="jobProfileOptions"
					:value="subLinkActiveKey === 'addJobProfile' ? undefined : subLinkActiveKey"
					@change="jobProfileChanged"
				/>
			</div>
			<div>
				<a href="/kundenbereich/jobs/anlegen">
					<Icon icon="plus"/>
				</a>
			</div>
		</div>
	</nav>
</template>

<script>
import Logout from "@/api/auth/Logout";
import MessagesLink from "@/vue/common/sub-navigation/MessagesLink";
import {mapState} from "vuex";
import Icon from "@/vue/icon/Icon";
import _ from "lodash";
import Select from "@/vue/common/form/Select.vue";
import {redirect} from "@/helper/Window";

const ITEMS = [
	{
		key: 'job-profiles',
		icon: 'heart',
		text: 'Jobs & Matches'
	},
	{
		key: 'employments',
		url: '/kundenbereich/zusagen',
		icon: 'signature',
		text: 'Zusagen',
		visibilityCheck: ({customer}) => customer?.employmentsCount > 0
	},
	{
		key: 'sendoffs',
		url: '/kundenbereich/verabschiedungen',
		icon: 'wave',
		text: 'Verabschiedungen',
		visibilityCheck: ({customer}) => customer?.sendoffsCount > 0
	},
	{
		key: 'exclusions',
		url: '/kundenbereich/ausschluesse',
		icon: 'lock',
		text: 'Kein Interesse',
		visibilityCheck: ({customer}) => customer?.exclusionsCount > 0
	},
	{
		key: 'security',
		url: '/kundenbereich/sicherheit',
		icon: 'cloud',
		text: 'Daten & Sicherheit',
	},
	{
		key: 'billing',
		url: '/kundenbereich/verrechnung',
		icon: 'coins',
		text: 'Verrechnung',
	},
];
export default {

	components: {
		Select,
		MessagesLink,
		Icon,
	},

	props: {
		page: {
			type: String,
			required: false,
		},
		only: {
			type: Array,
			required: false,
		},
		subLinkActiveKey: {
			type: String,
			required: false,
		},
	},

	computed: {
		...mapState('auth', [
			'customer'
		]),
		items ()
		{
			return _.filter(
				ITEMS,
				item =>
				{
					return this.shouldShow(item.key);
				}
			);
		},
		jobProfileOptions ()
		{
			if (!this.customer)
			{
				return [];
			}

			return this.customer.jobProfiles.map(jobProfile =>
			{
				return {
					value: jobProfile.id,
					text: jobProfile.name
				};
			});
		}
	},

	methods: {
		shouldShow (key)
		{
			const config = _.find(ITEMS, item => item.key === key);

			return (!this.only || _.includes(this.only, key))
				&& (!config?.visibilityCheck || config.visibilityCheck({customer: this.customer}));
		},
		jobProfileChanged (jobProfileId)
		{
			redirect('/kundenbereich/jobs/' + jobProfileId);
		},
		async logout ()
		{
			try
			{
				await new Logout().call();

				location.href = '/auth/login';
			}
			catch (e)
			{

			}
		},
	}
}
</script>
